/**
 * Duplicated track marquee. The second copy is aria-hidden so screen readers
 * hear the list once, and the animation pauses on hover.
 */
const Marquee = ({ items, speed = "animate-marquee", className = "" }) => (
  <div className={`mask-fade-x overflow-hidden ${className}`}>
    <div className={`flex w-max ${speed} pause-on-hover`}>
      {[0, 1].map((copy) => (
        <div
          key={copy}
          className="flex shrink-0 items-center"
          aria-hidden={copy === 1 ? "true" : undefined}
        >
          {items.map((item, index) => (
            <span
              key={`${copy}-${index}`}
              className="flex items-center gap-4 px-7"
            >
              {item}
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);

export default Marquee;
